import GitCoinETH from '@/assets/website/gitcoin_eth.png';
import GitCoinImg from '@/assets/donation/gitcoinicon_web.png';
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { apiOrgGotcoinOrg } from '@/apis/donation';
import Typography from '@/components/typography';
import { checkoutToken } from '@/utils/checkLogin';

export default function GitcoinCard() {
  const [info, setInfo] = useState({ claimedCount: 0 });
  const renderRef = useRef(true);

  const navigate = useNavigate();
  const handleGetOrg = async () => {
    const orgData: any = await apiOrgGotcoinOrg();
    console.log('orgData', orgData);
    if (orgData) {
      setInfo(orgData);
    }
  };

  useEffect(() => {
    if (renderRef.current) {
      renderRef.current = false;
      handleGetOrg();
      // if (localStorage.getItem('token')) {
      //   const isLoginout = checkoutToken();
      //   if (isLoginout) {
      //     handleGetOrg();
      //   }
      // }
    }
  }, []);

  return (
    <div className="min-h-[392px] w-full justify-center bg-[#F0F8EF]">
      <div className="mx-10 flex flex-wrap justify-center pt-9">
        <div className="w-1/2">
          <img className="mx-auto w-60" src={GitCoinETH}></img>
        </div>
        <div className="mb-20 mt-10 items-center justify-center">
          <div className="mt-9 flex items-center justify-center ">
            <img className="w-52" src={GitCoinImg} alt="" />
            <Typography className="ml-[10px] flex h-[26px] items-center justify-center rounded-[6px] bg-[#F3F6F4] py-[3px] px-[19px]">
              {info.claimedCount} Vitae Claimed
            </Typography>
          </div>
          <div className="mt-3  text-center text-lg text-[#4E4E4E]">
            Free mint a non-transferable NFT for your donation
          </div>
          <div className="mx-auto my-6 w-64 rounded-[30px] border bg-[#fff]">
            <p
              className="flex cursor-pointer items-center justify-center rounded-[30px] border px-[36px] py-[14px] text-[18px] leading-[18px] text-[#000]"
              style={{
                lineHeight: '100%',
                borderStyle: 'solid',
                fontWeight: '700',
                background:
                  'linear-gradient(90deg, rgba(106.73, 174.25, 153.99, 0.46), rgba(168.58, 252.88, 237.70, 1))',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: '#4E4E4E'
              }}
              onClick={() => navigate('/donation/gitcoin', { replace: true })}
            >
              Claim Now
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
